module.exports = __webpack_public_path__ + "static/media/app_store_badge.c3cbe624.webp";